import { useCallback } from 'react';

export const useFullscreenSafe = () => {
  const enterFullscreen = useCallback((element: HTMLElement | null) => {
    if (element && !document.fullscreenElement) {
      element.requestFullscreen?.().catch((err) => {
        console.error('Lỗi khi vào fullscreen:', err);
      });
    }
  }, []);

  const exitFullscreen = useCallback(() => {
    if (document.fullscreenElement) {
      document.exitFullscreen?.().catch((err) => {
        console.error('Lỗi khi thoát fullscreen:', err);
      });
    }
  }, []);

  const toggleFullscreen = useCallback(
    (element: HTMLElement | null) => {
      if (document.fullscreenElement) {
        exitFullscreen();
      } else {
        enterFullscreen(element);
      }
    },
    [enterFullscreen, exitFullscreen]
  );

  return { enterFullscreen, exitFullscreen, toggleFullscreen };
};
